import React from 'react';
import styled from 'styled-components';
import { formatDateToDDMMYYYY } from '../Helpers/dateFns';

const TrackingContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  overflow: hidden;
`;

const Timeline = styled.div`
  position: relative;
  margin-left: 20px;
  margin-right: 220px;
  &::before {
    content: '';
    position: absolute;
    left: 11px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #DADADA;
  }
`;

const Step = styled.div`
  position: relative;
  padding: 10px 0;
  display: flex;
  align-items: start;
  font-size: 14px;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    left: 14px;
    top: 30px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #DADADA;
  }

  &.important {
    font-weight: bold;
  }

  &:last-child::after {
    content: none;
  }
`;

const StepIcon = styled.div`
  padding-right: 10px;
`;

const StepContent = styled.div`
  padding-left: 30px;
  flex: 1;
`;

const StepTime = styled.div`
  color: #888888;
  margin-bottom: 3px;
`;

const StepMessage = styled.div`
  color: #333;
`;

const StepImage = styled.img`
  max-width: 400px;
  max-height: 400px;
  object-fit: contain;
  border-radius: 4px;
  position: fixed;
  right: 70px;
  top: 210px;
`;

const TrackingDetails = ({ trackingData }) => {
  return (
    <TrackingContainer>
      <Timeline>
        {trackingData.map((step, index) => (
          <Step key={index} className={step.isImportant ? 'important' : ''}>
            <StepContent>
              <StepTime>{formatDateToDDMMYYYY(step.TimeAtPoint, true)}</StepTime>
              <StepMessage>{step.StatusPointDescription}</StepMessage>
            </StepContent>
            {index === 0 && step.StatusPointImage && (
              <StepImage src={`data:image/gif;base64,${step.StatusPointImage}`} alt="Status" />
            )}
          </Step>
        ))}
      </Timeline>
    </TrackingContainer>
  );
};

export default TrackingDetails;
